import { selectedAttributesV2 } from '@/constants/selectedAttributes';
import axios from '../axios-config';

/*
===============================|> All Category APis <|===============================
01 |--> get category tree
02 |--> get products by category id
===============================|> All Category APis <|===============================
*/

// 01- =============> get category tree
const getCategoryTree = async (locale = 'ar') => {
  const config = {
    baseURL: process.env.NEXT_PUBLIC_API_BASEURL.replace('v1', 'v2'),
    method: 'get',
    url: `/mstore/category/tree/${locale}`,
  };

  try {
    const req = await axios(config);

    return req;
  } catch (error) {
    return error;
  }
};

const getTopCategoryAndBrand = async (handshake, categoryId) => {
  const config = {
    method: 'GET',
    url: `/customer/topCategoryAndBrand?categoryId=${categoryId}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
      'Content-Type': 'application/json',
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

// 02- =============> get products by category id
// * sortBy can be position | price
// * sortDir can be ASC | DESC
const getProductsByCategoryId = async ({
  categoryId,
  pageSize = 30,
  pageNo = 0,
  query = 'sortBy=position&sortDir=ASC',
  getFullResponse = true,
}) => {
  // Validate required parameters
  if (!categoryId) {
    throw new Error('CategoryId are required.');
  }
  // Prepare request configuration
  const config = {
    method: 'get',
    url: `/search/products/facets/category/${categoryId}?pageNo=${pageNo}&pageSize=${pageSize}&${query}`,
  };

  if (!getFullResponse) {
    config.url += `&${selectedAttributesV2}`;
  }

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getProductsByCategoryIdV2 = async ({
  categoryId,
  pageSize = 30,
  pageNo = 0,
  query = 'sortBy=position&sortDir=ASC',
  getFullResponse = true,
  locale = 'ar',
}) => {
  // Validate required parameters
  if (!categoryId) {
    throw new Error('CategoryId are required.');
  }
  // Prepare request configuration
  const config = {
    baseURL: process.env.NEXT_PUBLIC_API_BASEURL.replace('v1', 'v2'),
    method: 'get',
    url: `/search/category/facets/${locale}/${categoryId}?pageNo=${pageNo}&pageSize=${pageSize}&${query}`,
  };

  if (!getFullResponse) {
    config.url += `&${selectedAttributesV2}`;
  }

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getFilterableAttributesCategory = async (handshake, categoryId) => {
  const config = {
    method: 'get',
    url: `/filterable-attributes/category/${categoryId}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };

  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getFilterableAttributes = async (handshake, categoryId) => {
  const config = {
    method: 'get',
    url: `filterable-attributes/category/${categoryId}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };
  try {
    const req = await axios(config);
    return req;
  } catch (error) {
    return error;
  }
};

export {
  getCategoryTree,
  getProductsByCategoryId,
  getFilterableAttributesCategory,
  getFilterableAttributes,
  getTopCategoryAndBrand,
  getProductsByCategoryIdV2,
};
